SnowplowEventTracker = require('./snowplow_event_tracker').SnowplowEventTracker
require('./snowplow_helper_instance')

window.SB or= {}

window.SB.eventDefinitions = ($, global) ->
  "use strict"

  removePiiAnswer = [
    # Customer and addresses
    'customer_title',
    'customer_first_name',
    'customer_last_name',
    'customer_email_address',
    'preapp_email_address',
    'customer_telephone_number',
    'customer_alternative_telephone_number',
    'customer_address_1_pre_quote',
    'customer_address_2_pre_quote',
    'customer_town_pre_quote',
    'customer_postcode_pre_quote',
    'customer_address_1',
    'customer_address_2',
    'customer_town',
    'customer_postcode',
    'address_1_pre_quote',
    'address_2_pre_quote',
    'uk_postcode_pre_quote',
    'town_pre_quote',
    'owner_first_name',
    'owner_last_name',
    'beneficiary_first_name',
    'beneficiary_last_name',
    'gender',
    # Blueprint versions of above questions
    'customer_first_name_-_blueprint',
    'customer_last_name_-_blueprint',
    'customer_email_address_-_blueprint',
    'customer_telephone_number_-_blueprint',
    # Workers compensation
    'dynamic_ssn_fein',
    'ssn',
    'fein',
    # CCJs
    'sof_county_court_judgement_online_yes',
    'sof_county_court_judgement_online_no',
    'sof_ccj_count',
    'sof_ccj_value',
    'sof_ccj_date',
    'sof_court_judgement_yes',
    'sof_court_judgement_no',
    'ccj_date',
    'sof_single_ccj_no',
    'sof_single_ccj_yes',
    'sof_ccj_yes',
    'sof_ccj_no',
    'ccj_count',
    # Banruptcy/Liquidations
    'sof_bankrupt_yes',
    'sof_bankrupt_no',
    'sof_multiple_bankruptcies_yes',
    'sof_multiple_bankruptcies_no',
    'bankruptcy_date',
    'sof_single_bankruptcy_no',
    'sof_single_bankruptcy_yes',
    'sof_bankruptcy_yes',
    'sof_bankruptcy_no',
    'bankruptcy_discharged',
    'sof_liquidation_yes',
    'sof_liquidation_no'
    'sof_multiple_liquidations',
    'liquidation_date',
    # Criminal convictions
    'sof_criminal_offence_yes',
    'sof_criminal_offence_no',
    'sof_criminal_yes',
    'sof_criminal_no',
    # Hospital cash plan
    'hcp_date_of_birth_1',
    'hcp_date_of_birth_2',
    'hcp_date_of_birth_3',
    'hcp_date_of_birth_4',
    'hcp_date_of_birth_5',
    'hcp_date_of_birth_6',
    'hcp_date_of_birth_7',
    'hcp_date_of_birth_8',
    'hcp_date_of_birth_9',
    'hcp_date_of_birth_10',
    # Claims / circumstances
    'sof_previous_claims_yes',
    'sof_previous_claims_no',
    'sof_claims_yes',
    'sof_claims_no',
    'sof_property_claims_in_the_last_5_years_yes',
    'sof_property_claims_in_the_last_5_years_no',
    'sof_property_claims_in_the_last_0_to_4_years_yes',
    'sof_property_claims_in_the_last_0_to_4_years_no',
    'claim_count',
    'sof_number_of_claims',
    'number_of_claims_in_last_5_years',
    'number_of_claims_in_time_owned',
    'date_of_incident_1',
    'date_of_incident_2',
    'date_of_incident_3',
    'date_of_incident_4',
    'date_of_incident_5',
    'type_of_incident_1',
    'type_of_incident_2',
    'type_of_incident_3',
    'type_of_incident_4',
    'type_of_incident_5',
    'incident_value_1',
    'incident_value_2',
    'incident_value_3',
    'incident_value_4',
    'incident_value_5',
    'sof_pollution_disease_claims_yes',
    'sof_pollution_disease_claims_no',
    'sof_potential_claims_yes',
    'sof_potential_claims_no',
    'sof_previous_circumstances_yes',
    'sof_previous_circumstances_no',
    'sof_possible_claims_yes',
    'sof_possible_claims_no',
    'date_of_possible_incident',
    'type_of_possible_incident',
    'possible_incident_value',
    'sof_property_claims_yes',
    'sof_property_claims_no',
    'sof_liability_claims_yes',
    'sof_liability_claims_no',
    # Van
    'van_registration',
    # Other business / policy related
    'sof_disqualified_director_yes',
    'sof_disqualified_director_no',
    'sof_insurance_refused_yes',
    'sof_insurance_refused_no',
    'sof_insurance_declined_yes',
    'sof_insurance_declined_no',
    'insurance_refused',
  ]
  # These questions are radio buttons and we want to remove the yes/no from the question name
  # as the answer is in the question name
  # e.g. have_secondary_trade_yes -> have_secondary_trade
  # by doing it this way we can ensure prepop and pre-existing data is not affected
  removeRadioAnswerFromQuestions = [
    'have_secondary_trade_yes',
    'have_secondary_trade_no',
  ]

  numericalAnswers = [
    'years_trading',
    'employee_count',
    'annual_revenue',
    'employee_payroll'
  ]

  ## Tracker registration API
  #
  # - eventName
  # - trigger: actionName
  # - send: (eventName, element) -> #function body to call snowplowHelper
  #
  if global.snowplowHelper?
    tracker = global.EventTracker = new SnowplowEventTracker
  else
    FakeEventTracker = require('./fake_event_tracker').FakeEventTracker
    tracker = global.EventTracker = new FakeEventTracker

  tracker.register "pageset_section_changed",
    send: (eventName, dataset, sectionIndex, sectionComplete) ->
      site           = $('meta[name="site"]').attr('content')
      vertical       = $('meta[name="vertical_for_event"]').attr('content')
      payload        = {
        site: site,
        vertical: vertical,
        page_index: dataset.pageIndex,
        page_name: dataset.pageName,
        section_name: dataset.sectionName,
        section_index: sectionIndex,
        section_complete: sectionComplete
      }

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
        payload,
        global.snowplowHelper.distributionChannelContext(
          version: '1-0-0',
          serviceChannelIdentifier: site
        )
      )

  tracker.register "primary_detail_selected",
    trigger: "change"
    send: (eventName, element, fromViewAllTradeList = false, searchId = null, redirectedFromVertical = null, businessUnit = null, scope = null, selectedIndex = -1, isTradePrefilled = false) ->
      site                 = $('meta[name="site"]').attr('content')
      vertical             = redirectedFromVertical || $('meta[name="vertical_for_event"]').attr('content')
      primary_detail       = element.val?() or element

      # if the trade selected is 'General contractor' then the event is from the general contractor popup modal, do not send the event
      # the event will instead, for this trade, be handled based upon interactions within the modal itself
      isFromModal = false
      if (typeof element.attr == 'function')
        isFromModal = element.attr('data-from-modal') == 'true'

        # Don't track automatic change events from modal-driven trade changes
        # The modal JavaScript will manually trigger this event with data-from-modal="true"
        isAutomaticChangeFromModal = element.attr('data-suppress-auto-tracking') == 'true'
        if isAutomaticChangeFromModal
          return

      if primary_detail == 'General contractor'
        return unless isFromModal

      location             = (window.location.hostname + window.location.pathname).match(/^(.*\/)[^\/]+$/)[1];
      isUSPage             = businessUnit is "simplybusiness_us"
      selectedLocation     = if isFromModal then null else if scope isnt null and isUSPage then (if scope.match?(/^Coverage(\s|%20)selection$/) then "trade_selector_pre_app" else "trade_selector_vertical") else null
      selectedListPosition = if isFromModal then null else if isUSPage and selectedIndex >= 0 then String(selectedIndex + 1) else null
      businessUnit         = if isUSPage then businessUnit else null

      # if we have an actual element, we can get the search id from the data attribute
      if (typeof element.data == 'function')
        searchId = element.data('search-id')

      selected_type = if fromViewAllTradeList then "view_all_trades" else "trade_selector"

      # Check if we just redirected from view trade list
      # If so, this is duplicate page load event
      isRedirectFromTradeList = sessionStorage.getItem('redirectingFromTradeList') == 'true'

      if isRedirectFromTradeList and isTradePrefilled
        sessionStorage.removeItem('redirectingFromTradeList')
        return

      if isFromModal
        selectionMethod = "general_contractor_popup"
      else if selected_type is "trade_selector"
        if isUSPage and isTradePrefilled
          selectionMethod = 'pre-filled'
          selectedLocation = null
        else
          selectionMethod = if $('.js-ai-trade-search').length
            if isUSPage then 'genAI' else 'GenAI'
          else
            if isUSPage then 'legacy' else 'Legacy'
      else if selected_type is "view_all_trades"
        selectionMethod = 'direct_link'
        location = location + "trades"

      if primary_detail
        if vertical in ['Landlord', 'Commercial landlord']
          vertical = switch primary_detail
            when 'residential' then 'Landlord'
            when 'commercial', 'mixed' then 'Commercial landlord'
            else vertical

        payload = {
          site: site
          vertical: vertical
          primary_detail: primary_detail
          selected_type: selected_type
          location: location
          selection_method: selectionMethod
        }

        payload.search_id = searchId if searchId
        # Only include US-specific fields for US business unit
        payload.business_unit = businessUnit if businessUnit
        payload.selected_list_position = selectedListPosition if isUSPage
        payload.selected_location = selectedLocation if isUSPage

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-4-0",
          payload,
          global.snowplowHelper.distributionChannelContext(
            version: '1-0-0',
            serviceChannelIdentifier: site
          )
        )

  # !!!!! PLEASE NOTE !!!!!
  # Any changes here must also be replicated in the
  # state_question_answered event's form_question_answered sections
  tracker.register "form_question_answered",
    trigger: "change"
    send: (eventName, element) ->
      site           = $('meta[name="site"]').attr('content')
      vertical       = $('meta[name="vertical_for_event"]').attr('content')
      journey_id     = $('meta[name="journey_id"]').attr('content')
      question       = element.attr('id')
      sectionDataset = element.closest('.form-section').data() || {}

      if removePiiAnswer.includes(question)
        answer = 'REDACTED'
        question = question.replace(/_(yes|no)$/, '')
      else if removeRadioAnswerFromQuestions.includes(question)
        question = question.replace(/_(yes|no)$/, '')
        answer = element.val()
      else if numericalAnswers.includes(question)
        numeric_answer_expected = true
        answer = parseInt(element.val().replace(/[^0-9]/g, ""))
      else
        answer = element.val()

      payload        = {
        site: site
        vertical: vertical
        journey_id: journey_id
        page_index: sectionDataset.pageIndex
        page_name: sectionDataset.pageName
        section_name: sectionDataset.sectionName
        question: question
        answer: answer
      }

      answer_is_valid = answer || numeric_answer_expected and answer is 0

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-4",
        payload,
        global.snowplowHelper.serviceChannelContext(
          version: '1-0-1',
          serviceChannelIdentifier: site
        )
      ) if answer_is_valid


    ## state_question_answered event

    stateQuestionAnsweredLocalStorageKey = "stateQuestionAnsweredHistory"

    if not localStorage.getItem(stateQuestionAnsweredLocalStorageKey)
      localStorage.setItem(stateQuestionAnsweredLocalStorageKey, JSON.stringify([]))

    tracker.register "state_question_answered",
    trigger: "change"
    send: (eventName, element) ->
      # For `form_question_answered` event
      vertical           = $('meta[name="vertical_for_event"]').attr('content')
      site               = $('meta[name="site"]').attr('content')
      journey_id         = $('meta[name="journey_id"]').attr('content')
      question           = element.attr('id')
      sectionDataset     = element.closest('.form-section').data() || {}
      answer             = {}
      # For `state_question_answered` event
      vertical_for_state = $('meta[name="vertical_for_event"]').attr('content') || null
      is_state_prefilled = element.attr('state-prefilled')
      selected_type      = element.attr('selected-type')
      state              = element.val()
      selected_products  = element.attr('selected-products') || null

      ## -------------------------------------------
      ## Start of `form_question_answered` SECTION
      ## -------------------------------------------

      if removePiiAnswer.includes(question)
        answer = 'REDACTED'
        question = question.replace(/_(yes|no)$/, '')
      else if removeRadioAnswerFromQuestions.includes(question)
        question = question.replace(/_(yes|no)$/, '')
        answer = element.val()
      else if numericalAnswers.includes(question)
         numeric_answer_expected = true
         answer = parseInt(element.val().replace(/[^0-9]/g, ""))
      else
        answer = element.val()

      payload_for_form_question_answered = {
        site: site
        vertical: vertical
        journey_id: journey_id
        page_index: sectionDataset.pageIndex
        page_name: sectionDataset.pageName
        section_name: sectionDataset.sectionName
        question: question
        answer: answer
      }

      answer_is_valid = answer or numeric_answer_expected and answer is 0

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/form_question_answered/jsonschema/1-0-4",
        payload_for_form_question_answered,
        global.snowplowHelper.serviceChannelContext(
          version: '1-0-1',
          serviceChannelIdentifier: site
        )
      ) if answer_is_valid

      ## -------------------------------------------
      ## Start of `state_question_answered` SECTION
      ## -------------------------------------------

      stateQuestionAnsweredHistory = JSON.parse(localStorage.getItem(stateQuestionAnsweredLocalStorageKey))

      stateQuestionAnsweredHistory.push(is_state_prefilled)
      localStorage.setItem(stateQuestionAnsweredLocalStorageKey, JSON.stringify(stateQuestionAnsweredHistory))

      isInitialSelection = stateQuestionAnsweredHistory.length <= 1

      selection_method = if is_state_prefilled is "true" and isInitialSelection is true then "geolocation" else "dropdown"

      payload_for_state_question_answered = {
        vertical: vertical_for_state
        selected_type: selected_type
        products: selected_products
        location: (window.location.hostname + window.location.pathname).match(/^(.*\/)[^\/]+$/)[1];
        url: window.location.hostname + window.location.pathname
        state: state
        selection_method: selection_method
      }

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
        payload_for_state_question_answered,
        global.snowplowHelper.serviceChannelContext(
          version: '1-0-1',
          serviceChannelIdentifier: site
        )
      ) if state

  #  This tracker assumes that the `name` attribute on all checkboxes matches the `name` on the question.
  #  The value from all checked checkboxes will be sent in the event in the `answer` field.
  #  The `question` will not be the `id` of the element triggered as that would be the individual checkbox id
  #  instead we use the `name` attribute as this is the real id of the question we are tracking
  tracker.register "checkbox_form_question_answered",
    trigger: "change"
    send: (eventName, element) ->
      site           = $('meta[name="site"]').attr('content')
      vertical       = $('meta[name="vertical_for_event"]').attr('content')
      journey_id     = $('meta[name="journey_id"]').attr('content')
      sectionDataset = element.closest('.form-section').data()
      name = element.attr('name')
      answer = {}

      for i in $("input[name=\"#{name}\"]")
        if i.checked and sectionDataset.sectionName is "You might also want" and sectionDataset.pageName is "Recommendations"
          answer["other_coverage_#{i.id}"] = i.value
        else if i.checked
          answer[i.id] = i.value

      answer = [JSON.stringify(answer)]

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-1",
        {
          site: site
          vertical: vertical
          journey_id: journey_id
          page_index: sectionDataset.pageIndex
          page_name: sectionDataset.pageName
          section_name: sectionDataset.sectionName
          question: name
          answer: answer
        }
      )

  tracker.register "comparison_page_cover_changed",
    send: (eventName, {name, action, from_value, to_value}) ->
      site           = $('meta[name="site"]').attr('content')

      unless action?
        if from_value? and from_value is "0"
          action = "add"
        else if to_value? and to_value is "0"
          action = "remove"
        else
          action = "change"

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
        {
          name       : name ? ""
          action     : action
          from_value : from_value ? ""
          to_value   : to_value ? ""
        },
        global.snowplowHelper.distributionChannelContext(
          version: '1-0-0',
          serviceChannelIdentifier: site
        )
      )

  tracker.register "view_excess_clicked",
    trigger: "click"
    send: (eventName, element) ->
      json = element.attr('data-event');
      data = JSON.parse(json);
      quote_id = data.quote_id;
      cover_name = data.cover_name;
      cover_limit = data.cover_limit;
      max_excess_amount = data.max_excess_amount;
      max_excess_type = data.max_excess_type;
      all_excess_values = data.all_excess_values;

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-1",
        {
          quote_id: quote_id
          cover_name: cover_name
          cover_limit: cover_limit
          max_excess_amount: max_excess_amount
          max_excess_type: max_excess_type
          all_excess_values: all_excess_values
        }
      )

  tracker.register "upsell_dropdown_clicked",
    trigger: "click"
    send: (eventName, dropdownName, selectedValue) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
        {
          dropdown_name: dropdownName
          selected_value: selectedValue
        },
        global.snowplowHelper.distributionChannelContext(
          version: '1-0-0',
          serviceChannelIdentifier: site
        )
      )

  tracker.register "upsell_button_clicked",
    trigger: "click"
    send: (eventName, buttonName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
        {
          button_name: buttonName
        },
        global.snowplowHelper.distributionChannelContext(
          version: '1-0-0',
          serviceChannelIdentifier: site
        )
      )

  tracker.register "upsell_selected",
    trigger: "click"
    send: (eventName, products) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "upsells"
        action   : "next_step_button_clicked"
        label    : products.join(', ')
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "view_wcomp_clicked",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      json = element.attr('view_wcomp_event_data')
      data = JSON.parse(json)

      global.snowplowHelper.trackFrontofficeStructEvent
        category : "wcomp"
        action   : "wcomp_link_click"
        label    : data.rfq_id
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "document_download_clicked",
    trigger: "click"
    send: (eventName, element) ->
      site           = $('meta[name="site"]').attr('content')
      vertical       = $('meta[name="vertical"]').attr('content')
      sectionDataset = element.closest('.form-section').data()

      json = element.attr('data-document-download-event')
      data = JSON.parse(json)
      document_name = data.document_name
      document_type = data.document_type
      quote_id = data.quote_id
      rfq_id = data.rfq_id

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
        {
          site: site
          vertical: vertical
          page_index: sectionDataset.pageIndex
          page_name: sectionDataset.pageName
          section_name: sectionDataset.sectionName
          document_name: document_name
          document_type: document_type
          quote_id: quote_id
          rfq_id: rfq_id
        }
      )

  tracker.register "advert_on_policy_sale_confirmation",
    trigger: "click"
    send: (eventName, element) ->
      global.snowplowHelper.trackAdClick(
        {
          targetUrl    :  element.attr("href")
          zoneId       : 'policy_sale_confirmation'
          advertiserId : 'simplybusiness'
          campaignId   : eventName
        }
      )

  tracker.register "mobile_call_button",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "marketing"
        action   : "link_click"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "partner_contact_link",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "thank_you_partner_contact"
        action   : "link_click"
        label    : eventName
        property : element.href
        serviceChannelIdentifier : site

  tracker.register "pop_print_certificate_cta",
    trigger: "click"
    send: (eventName) ->
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "ux"
        action   : "cta_clicked"
        label    : eventName
        serviceChannelIdentifier : 'simplybusiness'

  tracker.register "partner_handover_interstitial_shown",
    send: (eventName, site, setTimer) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : site
        action   : "handover_interstitial_shown"
        label    : setTimer
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "state_prepopulated_via_cloudflare",
    send: (eventName, state) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "cloudlfare"
        action   : "state_prepopulated_via_cloudflare"
        property : state
        serviceChannelIdentifier : site

  tracker.register "enter_contact_details_manually_cta_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "enter_contact_details_manually_cta"
        action   : "contact_details_entered_manually_clicked"
        serviceChannelIdentifier : site

  tracker.register "desktop_comparison_page",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "comparison_cta"
        action   : "link_click"
        label    : element.data('event-label') || element.text()
        serviceChannelIdentifier : site

  tracker.register "email_suggestion_displayed",
     send: (eventName, email, suggestion) ->
       site = $('meta[name="site"]').attr('content')
       global.snowplowHelper.trackFrontofficeStructEvent
         category : "ux"
         action   : "mailcheck_triggered"
         label    : suggestion
         property : email
         serviceChannelIdentifier : site

   tracker.register "email_suggestion_clicked",
     send: (eventName, email) ->
       site = $('meta[name="site"]').attr('content')
       global.snowplowHelper.trackFrontofficeStructEvent
         category : "ux"
         action   : "cta_clicked"
         label    : "email_correction"
         property : email
         serviceChannelIdentifier : site

  tracker.register "invalid_state_zip_code_entered",
    send: (eventName, elementName, elementValueMessage) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "quote_form"
        action   : eventName
        label    : elementName
        property : elementValueMessage
        serviceChannelIdentifier : site

  tracker.register "invalid_owner_payroll_entered",
    send: (eventName, elementName, elementValueMessage) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "quote_form"
        action   : eventName
        label    : elementName
        property : elementValueMessage
        serviceChannelIdentifier : site

  tracker.register "invalid_field_submitted",
    send: (eventName, elementName, elementValueMessage) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "quote_form"
        action   : eventName
        label    : elementName
        property : elementValueMessage
        serviceChannelIdentifier : site

  tracker.register "direct_debit_payment_selected",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "ux"
        action   : "cta_clicked"
        label    : eventName
        serviceChannelIdentifier : site

  tracker.register "direct_debit_annual_switch",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackStructEvent
        category : "direct_debit_cta"
        action   : "link_click"
        label    : window.location.href
        serviceChannelIdentifier : site

  tracker.register "login_raf_button_clicked",
    trigger: "click"
    send: (name, element) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "marketing"
        action   : "link_click"
        label    : element.text()
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "monthly_installments_cta",
    trigger: "click"
    send: (name) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "payment_buttons",
        action   : "button_click",
        label    : "monthly payments",
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "shopping_cart_cta",
    trigger: "click"
    send: (name, label) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "mobile_shopping_cart_icon",
        action   : "button_click",
        label    : label,
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "one_time_payment_cta",
    trigger: "click"
    send: (name) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "payment_buttons",
        action   : "button_click",
        label    : "one-time payment",
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "payment_option_cta",
    trigger: "click"
    send: (eventName, element) ->
      site          = $('meta[name="site"]').attr('content')
      button = 'monthly button' if element.hasClass('js-monthly-button')
      button = 'annual button' if element.hasClass('js-annual-button')

      window.snowplowHelper.trackFrontofficeStructEvent
        category : site,
        action   : 'payment_button_click',
        label    : button,
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "start_your_quote_generic_error",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "ux"
        action   : "cta_clicked"
        label    : eventName
        serviceChannelIdentifier : site

  tracker.register "start_your_quote_invalid_journey",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "ux"
        action   : "cta_clicked"
        label    : eventName
        serviceChannelIdentifier : site

  tracker.register "send_email_invalid_journey",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "ux"
        action   : "cta_clicked"
        label    : eventName
        serviceChannelIdentifier : site

  tracker.register "start_your_quote_missing_external_reference",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "ux"
        action   : "cta_clicked"
        label    : eventName
        serviceChannelIdentifier : site

  tracker.register "external_agent_authentication_failed",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "ux"
        action   : "cta_clicked"
        label    : eventName
        serviceChannelIdentifier : site

  tracker.register "help_text_opened",
    send: (eventName, primaryText, helpText) ->
      site           = $('meta[name="site"]').attr('content')
      vertical       = $('meta[name="vertical_for_event"]').attr('content')
      payload        = {
        site: site,
        vertical: vertical,
        primary_text: primaryText,
        help_text: helpText
      }
      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0", payload
      )

  tracker.register "cancellation#lookup_submit",
    trigger: "click"
    send: (eventName, primaryText) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "cancellation"
        action   : "cta_clicked"
        label    : "continue"
        property : primaryText
        serviceChannelIdentifier : site

  tracker.register "cancellation#change_my_cover",
    trigger: "click"
    send: (eventName, primaryText) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "cancellation"
        action   : "cta_clicked"
        label    : "change_my_cover"
        property : primaryText
        serviceChannelIdentifier : site

  tracker.register "cancellation#cancel_my_cover",
    trigger: "click"
    send: (eventName, primaryText) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "cancellation"
        action   : "cta_clicked"
        label    : "cancel_my_cover"
        property : primaryText
        serviceChannelIdentifier : site

  tracker.register "cancellation#policy_number_unknown",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "cancellation"
        action   : "link_clicked"
        label    : "policy_number_unknown"
        property : element.attr("href")
        serviceChannelIdentifier : site

  tracker.register "cancellation#policy_number_known",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "cancellation"
        action   : "link_clicked"
        label    : "policy_number_known"
        property : element.attr("href")
        serviceChannelIdentifier : site

  tracker.register "cancellation#covid_hub",
    trigger: "click"
    send: (eventName, primaryText) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "cancellation"
        action   : "cta_clicked"
        label    : "coronavirus_hub"
        property : primaryText
        serviceChannelIdentifier : site

  tracker.register "cancellation#lookup_form_error",
      trigger: "load"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "cancellation"
          action   : 'invalid_field_submitted'
          label    : 'cancel_policy_lookup_form_error'
          property : element.attr('data-form-error')
          serviceChannelIdentifier : site

  tracker.register "cancellation#lookup_success",
      trigger: "load"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "cancellation"
          action   : "lookup_success"
          label    : "cancel_policy_lookup_success"
          property : element.attr('lookup_success')
          serviceChannelIdentifier : site

    tracker.register "coronavirus_cover_lookup_success",
      trigger: "load"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "covid"
          action   : "lookup_success"
          label    : eventName
          property : element.attr('lookup_success')
          serviceChannelIdentifier : site

    tracker.register "coronavirus_cover_lookup_form_error",
      trigger: "load"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "covid"
          action   : 'invalid_field_submitted'
          label    : eventName
          property : 'Wrong policy number - Enter your policy number'
          serviceChannelIdentifier : site

    tracker.register "no_quotes#nfp_faq",
      trigger: "click"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackStructEvent
          category : "no_quotes"
          action   : "link_clicked"
          label    : "nfp_faq"
          property : element.attr("href")
          serviceChannelIdentifier : site

    tracker.register "percent_work_total_submitted",
      trigger: "click"
      send: (eventName, percentage) ->
        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : "percent_work"
          action   : "percent_work_total_submitted"
          label    : "Percent Work"
          property : percentage
          serviceChannelIdentifier : site

    tracker.register "trade_switch",
      trigger: "click"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : "trade_switch"
          action   : "trade_switch_online_retailers"
          label    : "Trade Switch Online Retailers"
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "request_policy_documents_selected",
      trigger: "click"
      send: (eventName, element) ->
        json = element.attr('manage_policy_event_data')
        data = JSON.parse(json);
        email_address = data.email_address
        business_unit = data.business_unit

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            email_address: email_address
            business_unit: business_unit
          }
        )

    tracker.register "request_certificate_of_insurance_selected",
      trigger: "click"
      send: (eventName, element) ->
        json = element.attr('manage_policy_event_data')
        data = JSON.parse(json);
        email_address = data.email_address
        business_unit = data.business_unit

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            email_address: email_address
            business_unit: business_unit
          }
        )

    tracker.register "updating_your_policy_contact_selected",
      trigger: "click"
      send: (eventName, element) ->
        json = element.attr('manage_policy_event_data')
        data = JSON.parse(json);
        email_address = data.email_address
        business_unit = data.business_unit

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            email_address: email_address
            business_unit: business_unit
          }
        )

    tracker.register "renewing_your_policy_contact_selected",
      trigger: "click"
      send: (eventName, element) ->
        json = element.attr('manage_policy_event_data')
        data = JSON.parse(json);
        email_address = data.email_address
        business_unit = data.business_unit

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            email_address: email_address
            business_unit: business_unit
          }
        )

    tracker.register "cancelling_your_policy_contact_selected",
      trigger: "click"
      send: (eventName, element) ->
        json = element.attr('manage_policy_event_data')
        data = JSON.parse(json);
        email_address = data.email_address
        business_unit = data.business_unit

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            email_address: email_address
            business_unit: business_unit
          }
        )

    tracker.register "making_a_claim_contact_selected",
      trigger: "click"
      send: (eventName, element) ->
        json = element.attr('manage_policy_event_data')
        data = JSON.parse(json);
        email_address = data.email_address
        business_unit = data.business_unit

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            email_address: email_address
            business_unit: business_unit
          }
        )

    tracker.register "getting_help_contact_selected",
      trigger: "click"
      send: (eventName, element) ->
        json = element.attr('manage_policy_event_data')
        data = JSON.parse(json);
        email_address = data.email_address
        business_unit = data.business_unit

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            email_address: email_address
            business_unit: business_unit
          }
        )

    tracker.register "post_purchase_cyber_placement_link",
      trigger: "click"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "post_purchase_cyber_placement"
          action   : "link_click"
          label    : eventName
          property : element.href
          serviceChannelIdentifier : site

    tracker.register "post_purchase_workers_compensation_continuation_link",
      trigger: "click"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "post_purchase_workers_compensation_continuation"
          action   : "link_click"
          label    : eventName
          property : element.href
          serviceChannelIdentifier : site

    tracker.register "post_referral_workers_compensation_continuation_link",
      trigger: "click"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "post_referral_workers_compensation_continuation_link"
          action   : "link_click"
          label    : eventName
          property : element.href
          serviceChannelIdentifier : site

    tracker.register "selected_upsell_oppurtunity",
      trigger: "click"
      send: (action) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "priming_question_test"
          action   : "selected_upsell_oppurtunity"
          label    : "Priming question GL Upsell test"
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "not_selected_upsell_oppurtunity",
      trigger: "click"
      send: (action) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "priming_question_test"
          action   : "not_selected_upsell_oppurtunity"
          label    : "Priming question GL Upsell test"
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "chat_events",
      trigger: "click"
      send: (eventName, action) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "marketing"
          action   : "link_click"
          label    : action
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "cross_sell_event",
      trigger: "click"
      send: (eventName, action, product) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "Cross Sell #{product} Insurance"
          action   : "button_clicked"
          label    : action
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "coverage_selection_learn_more_modal_opened",
      trigger: "click"
      send: (eventName, product) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "coverage_selection"
          action   : "learn_more_modal_opened"
          label    : product
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "recommendations_ai_agent_new_cta_clicked",
      trigger: "click"
      send: (eventName, product, prompt) ->
        return unless product

        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : product,
          action   : "recommendations_ai_agent_new_cta_clicked",
          label    : prompt,
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "coverage_selection_recommendations_coverage_added",
      trigger: "click"
      send: (eventName, product) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "coverage_selection"
          action   : "recommendations_coverage_added"
          label    : product
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "coverage_selection_recommendations_coverage_removed",
      trigger: "click"
      send: (eventName, product) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "coverage_selection"
          action   : "recommendations_coverage_removed"
          label    : product
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "purchased_policy_segment_covers",
      trigger: "load"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "segment-covers-purchased"
          label    : element.attr('covers')
          action   : eventName
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "external_agent_copied_quote_link",
      trigger: "click"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        user_identity_id = element.attr('data-user-identity-id');

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            user_identity_id: user_identity_id
          },
          global.snowplowHelper.serviceChannelContext(
            version: '1-0-1',
            serviceChannelIdentifier: site
          )
        )

    tracker.register "external_agent_clicked_start_new_quote",
      trigger: "click"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        user_identity_id = element.attr('data-user-identity-id');
        step_name = element.attr('data-step-name');

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            user_identity_id: user_identity_id,
            step_name: step_name,
          },
          global.snowplowHelper.serviceChannelContext(
            version: '1-0-1',
            serviceChannelIdentifier: site
          )
        )

    tracker.register "external_agent_clicked_download_policy_documents",
      trigger: "click"
      send: (eventName, element) ->
        site = $('meta[name="site"]').attr('content')
        user_identity_id = element.attr('data-user-identity-id');
        step_name = element.attr('data-step-name');

        global.snowplowHelper.trackUnstructEvent(
          "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
          {
            user_identity_id: user_identity_id,
            step_name: step_name,
          },
          global.snowplowHelper.serviceChannelContext(
            version: '1-0-1',
            serviceChannelIdentifier: site
          )
        )

    tracker.register "view_deductables_clicked",
      trigger: "click"
      send: (eventName) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "us-qcp-stacking-format"
          action   : "view_deductables_clicked"
          property : window.location.href
          label    : eventName
          serviceChannelIdentifier : site

    tracker.register "cover_limits_question_icon_clicked",
      trigger: "click"
      send: (eventName) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "us-qcp-stacking-format"
          action   : "cover_limits_question_icon_clicked"
          property : window.location.href
          label    : eventName
          serviceChannelIdentifier : site

    tracker.register "workers_compensation_price_details_clicked",
      trigger: "click"
      send: (eventName) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "us-qcp-stacking-format"
          action   : "workers_compensation_price_details_clicked"
          property : window.location.href
          label    : eventName
          serviceChannelIdentifier : site

    tracker.register "card_details_button_clicked",
      trigger: "click"
      send: (eventName, _) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "us-qcp-stacking-format"
          action   : "details_button_clicked"
          label    : eventName
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "cover_toggle_clicked",
      trigger: "click"
      send: (eventName, _) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "us-qcp-stacking-format"
          action   : "cover_toggle_clicked"
          label    : eventName
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "other_coverages_available_section_triggered_event",
      trigger: "click"
      send: (eventName, action) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "other_coverages_available_section"
          action   : action
          label    : eventName
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "change_your_selected_profession",
      trigger: "click"
      send: (name) ->
        question = document.querySelector('.control-block.trade-search').getAttribute('data-question')
        primaryTradeQuestion = document.querySelector("[data-question='#{question}']")
        primaryTradeAnswerBeforeChanging = primaryTradeQuestion.querySelector(".answer").textContent

        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : "change_your_selected_profession_button",
          action   : "change_your_selected_profession_button_clicked",
          label    : "Question: #{question}",
          property : primaryTradeAnswerBeforeChanging
          serviceChannelIdentifier : site

    tracker.register "trade_selector_clicked",
      trigger: "click"
      send: (name) ->
        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : "marketing",
          action   : "trade_selector_clicked",
          label    : "trade selector clicked",
          property : window.location.href
          serviceChannelIdentifier : site

  # Dynamically add 'data-track' attribute to US State wrapper element (variant in AB test)
  USStateSelectElementVariant = document.getElementsByClassName("us-state-search-wrapper")[0]

  if USStateSelectElementVariant
    USStateSelectElementVariant.setAttribute("data-track", "us_state_clicked_variant")

    tracker.register "us_state_clicked_variant",
      trigger: "click"
      send: (name) ->
        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : "marketing",
          action   : "us_state_clicked",
          label    : "US state clicked",
          property : window.location.href
          serviceChannelIdentifier : site

  # Dynamically add 'data-track' attribute to US State wrapper element (control in AB test)
  USStateSelectElementControl = document.querySelector("select#coverage_us_state")

  if USStateSelectElementControl
    USStateSelectElementControl.closest(".select-wrapper").setAttribute("data-track", "us_state_clicked_control")

    tracker.register "us_state_clicked_control",
      trigger: "click"
      send: (name) ->
        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : "marketing",
          action   : "us_state_clicked",
          label    : "US state clicked",
          property : window.location.href
          serviceChannelIdentifier : site

  tracker.register "us_state_error_message_displayed",
    trigger: "click"
    send: (name) ->
      site = $('meta[name="site"]').attr('content')
      value = document.querySelector("input#coverage_us_state").value

      global.snowplowHelper.trackFrontofficeStructEvent
        category : "marketing"
        action   : 'us_state_error_message_displayed'
        label    : 'US state error message displayed'
        property : value
        serviceChannelIdentifier : site

  tracker.register "welcome_back_error_page_shown",
    trigger: "load"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "welcome_back_error_page"
        action   : 'welcome_back_error_page_shown'
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "help_chat_for_question_clicked",
    trigger: "click"
    send: (name, element) ->
      site = $('meta[name="site"]').attr('content')
      questionName = element[0].getAttribute('data-question')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "help chat for question"
        action   : "help_chat_for_question_clicked"
        label    : questionName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "help_chat_clicked",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      console.log(element);
      console.log(element[0]);
      locationClicked = element[0].getAttribute('location-clicked')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "help chat"
        action   : "help chat clicked"
        label    : locationClicked
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "post_purchase_cyber_cross_sell_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "payment confirmation page"
        action   : "post purchase cyber cross sell clicked"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "post_purchase_wc_cross_sell_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "payment confirmation page"
        action   : "post purchase wc cross sell clicked"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "post_purchase_cyber_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "payment confirmation page"
        action   : "post purchase cyber cross sell clicked"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "post_purchase_bonds_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "payment confirmation page"
        action   : "post purchase surety bonds clicked"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "account_activation_clicked",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      locationClicked = element[0].getAttribute('location-clicked')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "payment confirmation page"
        action   : "account activation clicked"
        label    : locationClicked
        property : window.location.href
        serviceChannelIdentifier : site

    tracker.register "liberty_mutual_terms_and_conditions_clicked",
      trigger: "click"
      send: (eventName) ->
        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : "liberty mutual"
          action   : "liberty mutual terms and conditions clicked"
          label    : eventName
          property : window.location.href
          serviceChannelIdentifier : site

    tracker.register "liberty_mutual_privacy_policy_clicked",
      trigger: "click"
      send: (eventName) ->
        site = $('meta[name="site"]').attr('content')
        window.snowplowHelper.trackFrontofficeStructEvent
          category : "liberty mutual"
          action   : "liberty mutual privacy policy clicked"
          label    : eventName
          property : window.location.href
          serviceChannelIdentifier : site

  tracker.register "wc_continuation_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "payment confirmation page"
        action   : "wc continuation clicked"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "qdp_payment_toggle_clicked",
    trigger: "click"
    send: (eventName, toggleValue) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "uk_qdp_payment_toggle_#{toggleValue}",
        action   : "payment_toggle_clicked",
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "qdp_check_other_quotes_clicked",
    trigger: "click"
    send: (eventName, toggleValue) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "uk_qdp_check_other_quotes",
        action   : "check_other_quotes_clicked",
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "purchase_confirmation_into_account_activation_clicked",
    trigger: "click"
    send: (name, a_or_b) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "uk_24_04_purchase_confirmation_into_account",
        action   : "click",
        label    : "#{a_or_b}_cta_clicked",
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "purchase_confirmation_into_account_signin_clicked",
    trigger: "click"
    send: (name, a_or_b) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "uk_24_04_purchase_confirmation_into_account",
        action   : "click",
        label    : "#{a_or_b}_cta_clicked",
        property : window.location.href
        serviceChannelIdentifier : site

  ##### Conversational experiment ####

  tracker.register "conversational_experiment_how_can_we_help_submitted",
    trigger: "click"
    send: (eventName, element) ->
      selectedOption = $(element[0]).text()
      orderInList = $(element[0]).data('num-in-list')

      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "conversational_experiment_what_brings_here",
        action   : "conversational_experiment_what_brings_here_clicked",
        property    : selectedOption
        serviceChannelIdentifier : site
        value: orderInList

  tracker.register "conversational_experiment_business_name_submitted",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "conversational_experiment_business_name_next_step_btn",
        action   : "business_name_next_step_btn_clicked",
        label    : $("#js-convo-business-name-input").val(),
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "conversational_experiment_business_description_submitted",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "conversational_experiment_find_my_business_btn",
        action   : "find_my_business_btn_clicked",
        label    : $("#js-convo-business-description-input").val(),
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "conversational_experiment_primary_detail_selected",
    trigger: "click"
    send: (eventName, primary_detail) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "conversational_experiment_primary_detail_radio_button",
        action   : "primary_detail_radio_button_clicked",
        label    : primary_detail,
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "conversational_experiment_state_submitted",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "conversational_experiment_state_next_btn",
        action   : "state_next_btn_clicked",
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "conversational_experiment_input_field_clicked",
    trigger: "click"
    send: (eventName, nameOfInput) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "conversational_experiment_input_field",
        action   : "input_field_clicked",
        label    : nameOfInput,
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "conversational_experiment_back_btn_clicked",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      currentPage = $("#js-convo-wrapper").data("state").split("state-")[1]
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "conversational_experiment_back_btn",
        action   : "back_btn_clicked",
        label    : currentPage,
        property : window.location.href
        serviceChannelIdentifier : site
  ##### /Conversational experiment ####

  tracker.register "ai_trade_selector_find_my_business",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "ai_trade_selector_find_my_business_btn",
        action   : "click",
        label    : $(".js-ai-trade-search").val(),
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "qcp_back_to_application",
    trigger: "click"
    send: (eventName, element) ->
      site = $('meta[name="site"]').attr('content')
      payload = {
        journey_id               : $('meta[name="journey_id"]').attr('content')
        vertical                 : $('meta[name="vertical_for_event"]').attr('content')
      }
      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/qcp_back_to_application/jsonschema/1-0-0",
        payload,
        global.snowplowHelper.serviceChannelContext(
          version: '1-0-1',
          serviceChannelIdentifier: site
        )
      )

  tracker.register "payment_option_changed",
    trigger: "click"
    send: (eventName, value, coverNames) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "payment_option"
        action   : "payment_option_clicked"
        label    : value
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "edit_quote_button_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "payment_page_edit"
        action   : "edit_quote_button_clicked"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "go_back_to_quote_selection_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "payment_page_edit"
        action   : "go_back_to_quote_selection_clicked"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "cancel_return_to_checkout_button_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "payment_page_edit"
        action   : "cancel_return_to_checkout_button_clicked"
        label    : eventName
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "checkout_button_clicked",
    trigger: "click"
    send: (eventName, value, covers) ->
      site = $('meta[name="site"]').attr('content')
      if typeof covers.join is 'function'
        coversString = covers.join(', ')
      else
        coversString = ""
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "payment_page"
        action   : "checkout_button_clicked"
        label    : "#{value} - #{coversString}"
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "clicked_get_quotes_button",
    trigger: "click"
    send: (action) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "comparison_cta"
        action   : "link_click"
        label    : "Get quotes"
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "double_negative_question_modal",
    trigger: "click"
    send: (eventName, question) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : question.question,
        action   : "#{question.answer}_clicked",
        label    : eventName,
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "chatbot_interaction_option_selected",
    trigger: "click"
    send: (eventName, optionText) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "chatbot_interaction_option_selected",
        action   : "option_selected",
        label    : optionText,
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "chatbot_interaction_user_input_submitted",
    trigger: "click"
    send: (eventName, userInput) ->
      site = $('meta[name="site"]').attr('content')
      window.snowplowHelper.trackFrontofficeStructEvent
        category : "chatbot_interaction_user_input_submitted",
        action   : "send_message_btn_clicked",
        label    : userInput,
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "new_login_help_link_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "new_login_help_link_clicked"
        action   : "link_click"
        label    : "Accordion Opened"
        property : window.location.href
        serviceChannelIdentifier : site

  tracker.register "high_value_off_ramp_popup_opened",
    send: (eventName) ->
      site           = $('meta[name="site"]').attr('content')
      vertical       = $('meta[name="vertical_for_event"]').attr('content')
      journey_id     = $('meta[name="journey_id"]').attr('content')
      payload        = {
        site: site,
        vertical: vertical,
        journey_id: journey_id
      }

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
        payload,
        global.snowplowHelper.distributionChannelContext(
          version: '1-0-0',
          serviceChannelIdentifier: site
        )
      )

  tracker.register "high_value_off_ramp_popup_closed",
    send: (eventName) ->
      site           = $('meta[name="site"]').attr('content')
      vertical       = $('meta[name="vertical_for_event"]').attr('content')
      journey_id     = $('meta[name="journey_id"]').attr('content')
      payload        = {
        site: site,
        vertical: vertical,
        journey_id: journey_id
      }

      global.snowplowHelper.trackUnstructEvent(
        "iglu:com.simplybusiness/#{eventName}/jsonschema/1-0-0",
        payload,
        global.snowplowHelper.distributionChannelContext(
          version: '1-0-0',
          serviceChannelIdentifier: site
        )
      )

  tracker.register "visit_tivly_button_clicked",
  send: (eventName) ->
    site = $('meta[name="site"]').attr('content')
    global.snowplowHelper.trackFrontofficeStructEvent
      category : "tivly_referral"
      action   : eventName
      label    : "tivly"
      property : window.location.href
      serviceChannelIdentifier : site

  tracker.attach(document.documentElement)

  tracker.register "fomta_change_address_link_clicked",
    trigger: "click"
    send: (eventName) ->
      site = $('meta[name="site"]').attr('content')
      global.snowplowHelper.trackFrontofficeStructEvent
        category : "frontoffice_mta"
        action   : "frontoffice_mta_change_address_link_clicked"
        label    : "Frontoffice mta change address"
        property : window.location.href
        serviceChannelIdentifier : site

  # Bop Confirmation Popup
  tracker.register "bop_confirmation_popup_opened",
      trigger: "click"
      send: (eventName, product) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "coverage_selection"
          action   : "bop_confirmation_popup_shown"
          label    : "Bop confirmation popup shown"
          property : window.location.href
          serviceChannelIdentifier : site

  # Bop Confirmation Popup
  tracker.register "bop_confirmation_popup_closed_yes",
      trigger: "click"
      send: (eventName, product) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "coverage_selection"
          action   : "bop_confirmation_popup_closed"
          label    : "Yes, I do"
          property : window.location.href
          serviceChannelIdentifier : site

  # Bop Confirmation Popup
  tracker.register "bop_confirmation_popup_closed_no",
      trigger: "click"
      send: (eventName, product) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "coverage_selection"
          action   : "bop_confirmation_popup_closed"
          label    : "No, I don't"
          property : window.location.href
          serviceChannelIdentifier : site

  tracker.register "cancel_anytime_badge_clicked",
      trigger: "click"
      send: (eventName, product) ->
        site = $('meta[name="site"]').attr('content')
        global.snowplowHelper.trackFrontofficeStructEvent
          category : "combined_payment_page_selection"
          action   : "cancel_anytime"
          label    : product
          property : window.location.href
          serviceChannelIdentifier : site

window.SB.eventDefinitions(window.jQuery, window)
